

export default function SectionMoreButton({ 
  title, 
  onClick,
}) {

  if (!title) return <></>

  return (
    <div 
    className=""
    // className='mx-auto py-6 text-center' 
  >
    <button
      onClick={onClick}
      type="button"    
      className="w-full text-center  rounded-full py-3 px-9 text-base leading-6 text-gray-600 ring-1 ring-gray-200 hover:ring-crisp-600/50"
      // className="font-semibold text-crisp-600"      
      // className="inline-flex items-center px-10 py-2 border border-gray-300 shadow-sm text-base rounded-md text-gray-700 bg-white hover:bg-gray-50"
    >
      <span className="font-medium text-gray-800">
        {title}
      </span>
    </button>
  </div>
  ) 

}



